// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const EmptyAction = styled.span`
  height: 32px;
`;
